import { ArticleType } from "../__generated__/gql/graphql";

export default function formatArticleType(type: ArticleType): string {
  switch (type) {
    case ArticleType.Overview:
      return "Overview";
    case ArticleType.Listicle:
      return "Listicle";
    case ArticleType.HowToGuide:
      return "How-to Guide";
    default:
      return "Unknown";
  }
}
